import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { getInsuranceTypeLabel } from 'src/app/_enums/insurance-type.enum';
import { getPeriodicityLabel } from 'src/app/_enums/proposal.enums';
import { getSignatureTypeLabel } from 'src/app/_enums/signature-type.enum';
import { LanguageCode } from 'src/app/_helpers/nationalities';
import { ProposalDetails } from 'src/app/_types/proposals.type';
import { AddProposalModalComponent } from 'src/app/shared/components/add-proposal-modal/add-proposal-modal.component';
import { UpdatePolicyModalComponent } from 'src/app/shared/components/update-policy-modal/update-policy-modal.component';
import { ProposalProductsDisplayerComponent } from 'src/app/shared/components/view-proposals/proposal-products-displayer/proposal-products-displayer.component';
import { IconsModule } from 'src/app/shared/icons/icons.module';
import { CardComponent } from 'src/app/shared/ui-kit/card/card.component';
import { ExpansionPanelComponent } from 'src/app/shared/ui-kit/expansion-panel/expansion-panel.component';
import { environment } from 'src/environments/environment';

import { TaskDetailsService } from '../../task-details.service';
import { PolicyAcceptationMessageComponent } from './policy-acceptation-message/policy-acceptation-message.component';

/** « Information du contrat »; its documents are `TaskPolicyDocumentsComponent`'s. */
@Component({
  selector: 'app-task-policy-info',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    CardComponent,
    ExpansionPanelComponent,
    ProposalProductsDisplayerComponent,
    PolicyAcceptationMessageComponent,
    IconsModule,
    AddProposalModalComponent,
    UpdatePolicyModalComponent,
  ],
  templateUrl: './task-policy-info.component.html',
})
export class TaskPolicyInfoComponent {
  DATE_FORMAT = environment.DATE_FORMAT;

  lngCode =
    (this.cookieService.get('selectedCountryCode') as LanguageCode) || 'fr';

  getInsuranceTypeLabel = getInsuranceTypeLabel;

  getPeriodicityLabel = getPeriodicityLabel;

  constructor(
    private readonly cookieService: CookieService,
    private readonly taskDetailsService: TaskDetailsService
  ) {}

  protected get proposal(): ProposalDetails | null {
    return this.taskDetailsService.state.policy;
  }

  getSignatureTypeLabel = getSignatureTypeLabel;

  refreshTaskDetails() {
    this.taskDetailsService.refreshTaskDetails();
  }
}
